<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <PageTitle 
            :title="$t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />
        <section class="padding-vertical-content">
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoSector="{ changeStep }">
                    <SeleccionarZonaComponent
                        @zonaSeleccionada="(zona) => { 
                            zona_seleccionada = zona; 
                            changeStep(); 
                        }"
                        :sga_event_id="lista_abonados.sga_event_id"
                    />                   
                </template>
                <template #pasoAsiento="{ changeStep }">
                    <SeleccionarAsientosSga
                        tipo="abonos"
                        :zona="zona_seleccionada"
                        @sesionCreada="onSesionCreada"
                        @volver="() => {
                            zona_seleccionada = null;
                            eliminarDatos();
                            changeStep(true);
                        }"
                        :sga_event_id="lista_abonados.sga_event_id"
                        :sga_product_id="lista_abonados.sga_product_id"
                    />
                </template>
                <template #pasoDatos="{ changeStep }">
                    <DatosAbonosSGAComponent
                        :items_carrito="items_carrito"
                        :datos_abonos="datos_abonos"
                        @fillDatosAbonos="(datosAbonos) => { datos_abonos = datosAbonos }"
                        @setDatosCobro="(...args) => {
                            setDatosCobro(...args);
                            changeStep();
                        }"
                        @volver="() => {
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoResumen="{ changeStep }">
                    <ResumenCompraComponent
                        :items="items_carrito"
                        ga4-category="Abono"
                        :jet_id="jet_id"
                        :formulario="formulario"
                        :cart_id="cart_id"
                        @setDatosCobro="setDatosCobro"
                        @terminado="() => {
                            changeStep();
                        }"
                        @volver="() => {
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoTarjeta="{ changeStep }">
                    <ProcesarPago
                        :jet_id="jet_id"
                        :session_id="session_id"
                        @terminado="() => {
                            changeStep();
                        }"
                    />
                </template>
            </Stepper>
        </section>
    </div>
</template>

<script>
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import SeleccionarZonaComponent from './SeleccionarZonaComponent.vue';
    import SeleccionarAsientosSga from './SeleccionarAsientosSga.vue';
    import DatosAbonosSGAComponent from './DatosAbonosSGAComponent';
    import ResumenCompraComponent from '@/components/frontend/components/sga/ResumenCompraComponent.vue';
    import ProcesarPago from './ProcesarPago';
    import { trackBeginCheckout, trackAddPaymentInfo } from '@/composables/common/useGA4Events';
    import { useAbonoTracking } from '@/composables/front/analytics/useAbonoTracking';

    export default {

        data() {
            return {
                zona_seleccionada: null,
                items_carrito: null,
                session_id: null,
                formulario: null,
                jet_id: null,
                cart_id: null,
                datos_abonos: []
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            steps() {
                return [
                    { label: this.$t('abonados.seleccionar_sector'), slot: 'pasoSector' },
                    { label: this.$t('abonados.seleccionar_asientos'), slot: 'pasoAsiento' },
                    { label: this.$t('abonados.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('abonados.resumen'), slot: 'pasoResumen' }
                ]
            }
        },
        methods: {
            tiempoTerminado() {
                this.eliminarDatos();
                this.$refs.stepper.changeStep(false, true);
            },
            eliminarDatos() {
                if (this.cart_id) {
                    this.$store.dispatch(this.config.getVuexAlias('sga.cart.eliminar-datos'), { cart_id: this.cart_id }).then(() => {
                        this.datos_abonos = [];
                        this.items_carrito = null;
                        this.cart_id = null;
                    }).catch(error => {
                        console.log('Error al eliminar los datos:', error);
                    });
                }
                localStorage.removeItem('sga_abono_cart_id');
            },
            setDatosCobro(jet_id, formulario, session_id, cart_id) {
                this.jet_id = jet_id;
                this.formulario = formulario;
                this.session_id = session_id;
                this.cart_id = cart_id;

                const ga4Items = this.buildGA4Items();
                const totalValue = ga4Items.reduce((sum, item) => sum + item.price, 0);
                trackAddPaymentInfo(totalValue, 'EUR', 'Tarjeta de crédito', ga4Items);
            },
            buildGA4Items() {
                if (!this.items_carrito || !Array.isArray(this.items_carrito)) {
                    return [];
                }

                const totalPrecio = this.items_carrito.reduce((suma, item) => suma + (item.precio?.amount || 0), 0);
                return [
                    {
                        item_id: this.lista_abonados.id,
                        item_name: 'Abono zona ' + this.items_carrito[0].zona?.name || 'Abonados',
                        price: totalPrecio || 0,
                        quantity: this.items_carrito.length
                    }
                ]
            },
            onSesionCreada(items, carrito_id) {
                this.items_carrito = items;
                this.cart_id = carrito_id;
                this.setDatosAbonos();

                const { trackBeginCheckout } = useAbonoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });
                trackBeginCheckout({
                    abono_id: this.lista_abonados.id,
                    abono_name: this.lista_abonados.nombre,
                    lista_abonados: [{ precio_unitario: this.items_carrito?.reduce((sum, item) => sum + (parseFloat(item.precio?.amount) || 0), 0) || 0 }],
                    resumen_total: this.items_carrito?.reduce((sum, item) => sum + (parseFloat(item.precio?.amount) || 0), 0) || 0,
                    moneda: 'EUR',
                    items_carrito: this.items_carrito,
                });

                this.$refs.stepper.changeStep();
            },
            setDatosAbonos() {
                this.items_carrito?.forEach(item => {
                    this.datos_abonos.push({
                        id: item.id,
                        // Per-item documentation flags live at items_carrito[i] top level
                        // (backend-confirmed; NOT inside item.precio). Thread them into
                        // the per-item datos_abonos entry so the orchestrator can pass
                        // them to the child form via the existing sync contract.
                        // Initialize accumulator + inline-validation flag on the entry to
                        // avoid Vue 2.7 reactivity drop for late additions.
                        solicitar_documentacion: item.solicitar_documentacion === true,
                        texto_documentacion: item.texto_documentacion || '',
                        documentaciones: [],
                        documentacion_error: false,
                        name: "",
                        lastName: "",
                        gender: "",
                        gender_object: null,
                        identification: {
                            type: "",
                            value: ""
                        },
                        address: {
                            country: "",
                            city: "",
                            state: "",
                            zipCode: "",
                            streetLine1: ""
                        },
                        birthday: "",
                        email: "",
                        email_confirm: "",
                        phone: "",
                        error_telefono: 0
                    });
                });
            }
        },
        mounted() {
            this.eliminarDatos();

            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: "Datos de pago", slot: "pasoTarjeta" });
            }
        },
        components: {
            CuentaAtras, PageTitle, Stepper, SeleccionarZonaComponent, SeleccionarAsientosSga, DatosAbonosSGAComponent, ResumenCompraComponent, ProcesarPago
        }
    }
</script>
